<template>
  <v-app>
    <v-toolbar fixed color="white">
      <v-toolbar-title>
        <v-btn flat>
          <img src="static/img/logo.png" height="40">
        </v-btn>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn flat @click="logout" class="hidden-sm-and-down">
          Cerrar Sesión
        </v-btn>
      </v-toolbar-items>

      <v-avatar class="error hidden-md-and-up mr-3" size=30 @click="logout">
        <v-icon dark>exit_to_app</v-icon>
      </v-avatar>

      <change-language-dropdown custom-class="dropup"></change-language-dropdown>
    </v-toolbar>

    <v-content>
      <section class="legal-hero">
        <v-container>
          <v-layout align-center justify-center>
            <v-flex xs12 md8 text-xs-center>
              <h1 class="display-2 white--text font-weight-light mb-3">
                Comunicado Oficial
              </h1>
              <p class="headline white--text mb-4">
                Cese de operaciones en Chile
              </p>
            </v-flex>
          </v-layout>
        </v-container>
      </section>

      <section class="legal-content-section">
        <v-container class="legal-content">
          <v-layout row wrap>
            <v-flex xs12>
              <v-card class="elevation-4 pa-4">
                <div class="legal-text">
                  <p class="body-1 mb-4">
                    Informamos que, por razones contractuales con nuestra antigua contraparte local, wesmartPark dejará de operar en Santiago de Chile a partir del <b>31 de julio</b>.
                  </p>
                  
                  <p class="body-1 mb-4">
                    Estamos trabajando para regresar bajo gestión directa desde España.
                  </p>
                  
                  <p class="body-1 mb-4">
                    El cierre se produce tras detectar usos no autorizados de nuestra tecnología y modelo de negocio. Se ha decidido poner el caso en manos de la justicia.
                  </p>
                  
                  <p class="body-1 mb-4 typeform-container">
                  </p>

                  <p class="body-1 mb-4">
                    Gracias por su confianza.
                  </p>
                  
                  <p class="body-1 text-xs-right grey--text text--darken-2">
                    — El equipo de wesmartPark
                  </p>
                </div>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
      </section>
    </v-content>

    <dps-footer></dps-footer>
  </v-app>
</template>

<script>
import store from '@/store';
import DpsFooter from '@/components/commons/Footer';
import ChangeLanguageDropdown from '@/components/commons/ChangeLanguageDropdown.vue';

export default {
  name: 'ChileBlocker',
  components: {
    [DpsFooter.name]: DpsFooter,
    [ChangeLanguageDropdown.name]: ChangeLanguageDropdown
  },

  data() {
    return {
      typeformId: '01K10DV7TYVG9YZTMP7530VBKB'
    }
  },

  computed: {
    currentUser() {
      const username = (store.state.user && store.state.user.manager && store.state.user.manager.username) || 'anonymous';
      return username;
    },

    typeformHiddenParams() {
      // Crear el parámetro hidden en el formato correcto para Typeform
      const params = `username=${this.currentUser}`;
      return params;
    }
  },

  mounted() {
    this.loadTypeformHTML();
  },

  methods: {
    logout() {
      // Limpiar el estado de usuario
      store.commit('LOGOUT_USER');
      // Redirigir a la página pública principal
      this.$router.push('/');
    },

    loadTypeformHTML() {
      // Crear el contenedor de Typeform
      const container = document.querySelector('.typeform-container');
      container.innerHTML = `
        <div class="mail-wrapper" style="" lang="und" dir="auto">
          <table align="left" class="wrapper" border="0" cellpadding="0" cellspacing="0" role="presentation" 
                 style="background:#FFFFFF;background-color:#FFFFFF;width:100%;margin:0px 0px 40px 0px;">
            <tbody>
              <tr>
                <td>
                  <!--[if mso | IE]>
                  <table align="left" border="0" cellpadding="0" cellspacing="0" class="wrapper-outlook" 
                         role="presentation" bgcolor="#FFFFFF">
                    <tr>
                      <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
                  <![endif]-->
                  <div style="margin:0px auto;">
                    <table align="left" border="0" cellpadding="0" cellspacing="0" role="presentation" style="width:100%">
                      <tbody>
                        <tr>
                          <td style="direction:ltr;font-size:0px;padding:0;text-align:left">
                            <!--[if mso | IE]>
                            <table role="presentation" border="0" cellpadding="0" cellspacing="0">
                              <tr>
                                <td class="">
                                  <table align="left" border="0" cellpadding="0" cellspacing="0" class="" 
                                         role="presentation">
                                    <tr>
                                      <td style="line-height:0px;font-size:0px;mso-line-height-rule:exactly;">
                            <![endif]-->
                            <div class="" style="margin:0px auto;">
                              <table align="left" border="0" cellpadding="0" cellspacing="0" role="presentation" 
                                     style="width:100%">
                                <tbody>
                                  <tr>
                                    <td style="direction:ltr;font-size:0px;padding:0px 0;text-align:left">
                                      <!--[if mso | IE]>
                                      <table role="presentation" border="0" cellpadding="0" cellspacing="0">
                                        <tr>
                                          <td class="" style="vertical-align:top;">
                                      <![endif]-->
                                      <div class="" 
                                           style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%">
                                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" 
                                               style="vertical-align:top" width="100%">
                                          <tbody>
                                            <tr>
                                              <td align="left" class="" 
                                                  style="font-size:0px;padding:10px 0px 0px 0px;word-break:break-word">
                                                <div style="font-family:'Source Sans Pro',sans-serif;font-size:14px;font-weight:normal;line-height:32px;text-align:left;color:rgba(0, 0, 0, 0.87)">
                                                  ¿Desea ser informado/a sobre nuestra vuelta?
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td align="left" class="" 
                                                  style="font-size:0px;padding:20px 0px;word-break:break-word">
                                                  
                                                <div style="font-family:Ubuntu,Helvetica,Arial,sans-serif;font-size:13px;line-height:1;text-align:left;color:#000000">
                                                  <a target="_blank" href="https://wsp1.typeform.com/to/iyoAvYub?typeform-medium=embed-email#username=${encodeURIComponent(this.currentUser)}&amp;answers-0e17be11-ee53-433f-acae-493b671855f8=0e17be11-ee53-433f-acae-493b671855f8-yes" 
                                                     style="font-family:'Source Sans Pro',sans-serif;color:rgb(0, 188, 212);font-size:14px;line-height:18px;text-decoration:none;text-align:center;padding:10px 20px;border: 1px solid rgb(0, 188, 212);border-radius:2px;background-color:rgb(255, 255, 255)">
                                                    Sí, avísenme cuando regresen.
                                                  </a>
                                                </div>
                                              </td>
                                            </tr>
                                            <tr>
                                              <td align="left" class="" 
                                                  style="font-size:0px;padding:10px 0px;word-break:break-word">
                                                  
                                                <div style="font-family:Ubuntu,Helvetica,Arial,sans-serif;font-size:13px;line-height:1;text-align:left;color:#000000">
                                                  <a target="_blank" href="https://wsp1.typeform.com/to/iyoAvYub?typeform-medium=embed-email#username=${encodeURIComponent(this.currentUser)}&amp;answers-0e17be11-ee53-433f-acae-493b671855f8=0e17be11-ee53-433f-acae-493b671855f8-no" 
                                                     style="font-family:'Source Sans Pro',sans-serif;color:rgb(0, 188, 212);font-size:14px;line-height:18px;text-decoration:none;text-align:center;padding:10px 20px;border: 1px solid rgb(0, 188, 212);border-radius:2px;background-color:rgb(255, 255, 255)">
                                                    No, eliminen mis datos.
                                                  </a>
                                                </div>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      <!--[if mso | IE]>
                                          </td>
                                        </tr>
                                      </table>
                                      <![endif]-->
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <!--[if mso | IE]>
                                      </td>
                                    </tr>
                                  </table>
                                </td>
                              </tr>
                            </table>
                            <![endif]-->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <!--[if mso | IE]>
                      </td>
                    </tr>
                  </table>
                  <![endif]-->
                </td>
              </tr>
            </tbody>
          </table>
          <style>
            #outlook a{padding:0}
            body{margin:0;padding:0;-webkit-text-size-adjust:100%;-ms-text-size-adjust:100%}
            table,td{border-collapse:collapse;mso-table-lspace:0pt;mso-table-rspace:0pt}
            img{border:0;height:auto;line-height:100%;outline:none;text-decoration:none;-ms-interpolation-mode:bicubic}
            p{display:block;margin:13px 0}
            @media only screen and (min-width:480px){.mj-column-px-640{width:640px !important;max-width:640px}}
            .moz-text-html .mj-column-px-640{width:640px !important;max-width:640px}
            .mj-column-px-640{width:100% !important;max-width:640px}
            /*!sc*/
            data-styled.g1[id="sc-global-juhJZJ1"]{content:"sc-global-juhJZJ1,"}
            /*!sc*/
          </style>
          <link href="https://font.typeform.com/dist/google/ubuntu/index.css" rel="stylesheet" type="text/css">
        </div>
      `;
    }
  }
}
</script>

<style scoped>
.legal-hero {
  background: linear-gradient(to left, #36c6d3 0%, #42a5f5 100%);
  padding: 80px 0 60px 0;
  margin-top: 64px;
}

.legal-content-section {
  padding: 40px 0;
  background-color: #f5f5f5;
}

.legal-content {
  max-width: 900px;
  margin: 0 auto;
}

.legal-text {
  text-align: justify;
  line-height: 1.7;
}

.legal-list {
  margin: 0;
  padding-left: 20px;
}

.legal-list li {
  margin-bottom: 12px;
  line-height: 1.6;
}

.v-toolbar__title {
  font-weight: 500;
}

.v-card {
  border-radius: 8px !important;
}

@media (max-width: 600px) {
  .legal-hero {
    padding: 60px 0 40px 0;
  }
  
  .legal-hero h1 {
    font-size: 2rem !important;
  }
  
  .legal-hero .headline {
    font-size: 1.25rem !important;
  }
}
</style>

<style>
/* Estilos globales para el Typeform (sin scoped) */
.typeform-container [data-tf-live] {
  width: 100% !important;
}

.typeform-container [data-tf-live] iframe {
  transform: scale(0.9) !important;
  transform-origin: top center !important;
  width: 110% !important;
  height: 450px !important;
  border: none !important;
  margin: 0 !important;
  padding: 0 !important;
  box-shadow: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/commons/ChileBlocker.vue